import { Link } from "react-router-dom";
import { useSite } from "@/lib/content";
import { SocialLinks } from "@/components/site/SocialIcons";

export default function Footer() {
  const { data: site } = useSite();
  const dexit = site?.dexit || [];
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-coal">
      <div className="px-5 md:px-10 py-16 md:py-24 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 flex flex-col gap-6">
          <img src="/assets/original_logo.png" alt="SEIMEN DEXTER" className="h-16 md:h-20 w-auto self-start object-contain" draggable="false" />
          <p className="text-[11px] tracking-[0.25em] text-white/50">HARD / INDUSTRIAL TECHNO</p>
          <p className="text-[11px] tracking-[0.25em] text-white/50">MANNHEIM / GERMANY — 165 BPM</p>
        </div>
        <div className="md:col-span-3 flex flex-col gap-3 text-sm">
          <span className="text-[11px] tracking-[0.25em] text-white/40 mb-1">CONNECT</span>
          <SocialLinks socials={site?.socials} vertical className="gap-3" iconClass="h-4 w-4" showLabels />
          {site?.booking_email && (
            <a
              data-testid="footer-booking-email"
              href={`mailto:${site.booking_email}`}
              className="mt-3 text-white/70 hover:text-white break-all"
            >
              {site.booking_email}
            </a>
          )}
        </div>
        <div className="md:col-span-2 flex flex-col gap-3 text-sm">
          <span className="text-[11px] tracking-[0.25em] text-white/40 mb-1">DEXIT CONNECTION</span>
          {dexit.map((d, i) =>
            d.url ? (
              <a
                key={i}
                data-testid={`footer-dexit-${i}`}
                href={d.url}
                target="_blank"
                rel="noreferrer"
                className="text-white/70 hover:text-white"
              >
                {d.name}
              </a>
            ) : (
              <span key={i} className="text-white/70">
                {d.name}
              </span>
            )
          )}
        </div>
        <div className="md:col-span-2 flex flex-col gap-3 text-sm">
          <span className="text-[11px] tracking-[0.25em] text-white/40 mb-1">LEGAL</span>
          <Link data-testid="footer-impressum" to="/impressum" className="text-white/70 hover:text-white">
            IMPRESSUM
          </Link>
          <Link data-testid="footer-datenschutz" to="/datenschutz" className="text-white/70 hover:text-white">
            DATENSCHUTZ
          </Link>
        </div>
      </div>
      <div className="px-5 md:px-10 py-6 border-t border-line flex flex-col md:flex-row justify-between gap-2 text-[10px] tracking-[0.2em] text-white/30">
        <span>© {new Date().getFullYear()} SEIMEN DEXTER</span>
        <span>NOT JUST HARD. NOT JUST INDUSTRIAL.</span>
      </div>
    </footer>
  );
}
